import { render, staticRenderFns } from "./RouteView.vue?vue&type=template&id=298f5c2e&scoped=true"
import script from "./RouteView.vue?vue&type=script&lang=js"
export * from "./RouteView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298f5c2e",
  null
  
)

export default component.exports